const dict = {
  uk: {
    chooseRole: 'Оберіть свою роль',
    loginAsStudent: 'Увійти як Учень',
    loginAsTeacher: 'Увійти як Вчитель',
  },
  en: {
    chooseRole: 'Choose your role',
    loginAsStudent: 'Log in as Student',
    loginAsTeacher: 'Log in as Teacher',
  },
};

export default dict;
